const clientRequests = {
  // Page titles
  pageTitle: 'أرسل طلبك العقاري',
  pageSubtitle: 'صف ما تبحث عنه وسيتواصل معك أفضل الوسطاء المعتمدين',

  // Stepper steps
  steps: {
    propertyDetails: 'تفاصيل العقار',
    location: 'الموقع',
    budget: 'الميزانية',
    preferences: 'التفضيلات',
    contact: 'معلومات التواصل',
    // خطوات معالج «أضف طلبك» (pages/client-requests/CreateClientRequest.tsx).
    type: 'نوع الطلب',
    details: 'التفاصيل',
  },

  // Property type section
  propertyType: {
    title: 'نوع العقار',
    subtitle: 'اختر نوع العقار الذي تبحث عنه',
    apartment: 'شقة',
    villa: 'فيلا',
    land: 'أرض',
    building: 'عمارة',
    office: 'مكتب',
    shop: 'محل تجاري',
    warehouse: 'مستودع',
    farm: 'مزرعة',
    duplex: 'دوبلكس',
    penthouse: 'بنتهاوس',
    chalet: 'شاليه',
    compound: 'مجمع سكني',
  },

  // Transaction type
  transactionType: {
    title: 'نوع الصفقة',
    buy: 'شراء',
    rent: 'إيجار',
  },

  // Location section
  location: {
    title: 'الموقع المطلوب',
    subtitle: 'حدد المدينة والحي المفضل',
    city: 'المدينة',
    cityPlaceholder: 'اختر المدينة',
    district: 'الحي',
    districtPlaceholder: 'اختر الحي',
    districtOptional: 'الحي (اختياري)',
    anyDistrict: 'أي حي',
  },

  // Budget section
  budget: {
    title: 'الميزانية',
    subtitle: 'حدد نطاق الميزانية المناسب',
    min: 'الحد الأدنى',
    max: 'الحد الأقصى',
    minPlaceholder: 'من',
    maxPlaceholder: 'إلى',
    currency: 'ريال',
    flexible: 'الميزانية مرنة',
    flexibleDescription: 'يمكنني النظر في عروض أعلى قليلاً من الميزانية المحددة',
  },

  // Rental duration
  rentalDuration: {
    title: 'مدة الإيجار',
    monthly: 'شهري',
    quarterly: 'ربع سنوي',
    semiAnnual: 'نصف سنوي',
    annual: 'سنوي',
  },

  // Preferences section
  preferences: {
    title: 'التفضيلات',
    subtitle: 'أخبرنا بمتطلباتك الإضافية',
    rooms: 'غرف النوم',
    roomsPlaceholder: 'اختر',
    bathrooms: 'دورات المياه',
    bathroomsPlaceholder: 'اختر',
    area: 'المساحة (م²)',
    areaMin: 'الحد الأدنى',
    areaMax: 'الحد الأقصى',
    moveInDate: 'تاريخ الانتقال',
    moveInDatePlaceholder: 'اختر التاريخ',
    moveInFlexible: 'التاريخ مرن',
    notes: 'ملاحظات إضافية',
    notesPlaceholder: 'اكتب أي متطلبات أو تفضيلات إضافية...',
  },

  // Features/Amenities
  amenities: {
    title: 'المميزات المطلوبة',
    parking: 'موقف سيارات',
    pool: 'مسبح',
    garden: 'حديقة',
    elevator: 'مصعد',
    security: 'حراسة أمنية',
    gym: 'صالة رياضية',
    furnished: 'مفروش',
    maidRoom: 'غرفة خادمة',
    driverRoom: 'غرفة سائق',
    ac: 'تكييف مركزي',
    balcony: 'شرفة',
    kitchen: 'مطبخ',
  },

  // Contact section
  contact: {
    title: 'معلومات التواصل',
    subtitle: 'كيف يمكن للوسطاء التواصل معك؟',
    name: 'الاسم',
    namePlaceholder: 'اسمك الكامل',
    phone: 'رقم الجوال',
    phonePlaceholder: '05xxxxxxxx',
    email: 'البريد الإلكتروني',
    emailPlaceholder: 'example@email.com',
    emailOptional: 'البريد الإلكتروني (اختياري)',
    preferredContact: 'طريقة التواصل المفضلة',
    contactCall: 'مكالمة هاتفية',
    contactWhatsapp: 'واتساب',
    contactBoth: 'كلاهما',
    preferredTime: 'الوقت المفضل للتواصل',
    anytime: 'أي وقت',
    morning: 'صباحاً (8ص - 12م)',
    afternoon: 'ظهراً (12م - 5م)',
    evening: 'مساءً (5م - 9م)',
  },

  // Privacy options
  privacy: {
    title: 'خيارات الخصوصية',
    private: 'طلب خاص',
    privateDescription: 'لن يظهر طلبك للعامة، فقط للوسطاء المعتمدين',
    public: 'طلب عام',
    publicDescription: 'سيظهر طلبك في سوق الطلبات للجميع',
  },

  // Actions
  actions: {
    next: 'التالي',
    back: 'السابق',
    submit: 'إرسال الطلب',
    submitting: 'جاري الإرسال...',
    cancel: 'إلغاء',
    edit: 'تعديل',
    delete: 'حذف',
    viewOffers: 'عرض العروض',
  },

  // Success page
  success: {
    title: 'تم إرسال طلبك بنجاح!',
    subtitle: 'سيتواصل معك الوسطاء المعتمدون قريباً',
    requestNumber: 'رقم الطلب',
    whatNext: 'ماذا بعد؟',
    step1: 'سيراجع الوسطاء المعتمدون طلبك',
    step2: 'ستتلقى عروضاً من الوسطاء المناسبين',
    step3: 'اختر العرض الأنسب لك وتواصل مع الوسيط',
    viewMyRequests: 'عرض طلباتي',
    submitAnother: 'إرسال طلب آخر',
    backToHome: 'العودة للرئيسية',
  },

  // My requests page
  myRequests: {
    title: 'طلباتي',
    subtitle: 'تتبع طلباتك العقارية وعروض الوسطاء',
    noRequests: 'لا توجد طلبات',
    noRequestsDesc: 'لم تقم بإرسال أي طلبات عقارية بعد',
    createFirst: 'أرسل طلبك الأول',
    filter: {
      all: 'الكل',
      active: 'نشط',
      closed: 'مغلق',
      expired: 'منتهي',
    },
    offersCount: 'عرض',
    offersCountPlural: 'عروض',
    newOffers: 'عروض جديدة',
    viewDetails: 'عرض التفاصيل',
  },

  // Request status
  status: {
    active: 'نشط',
    closed: 'مغلق',
    expired: 'منتهي',
    pending: 'قيد المراجعة',
  },

  // Broker side - Request listing
  broker: {
    title: 'سوق الطلبات',
    subtitle: 'تصفح طلبات العملاء وقدم عروضك',
    filters: {
      title: 'تصفية النتائج',
      propertyType: 'نوع العقار',
      city: 'المدينة',
      budgetRange: 'نطاق الميزانية',
      transactionType: 'نوع الصفقة',
      clearAll: 'مسح الكل',
    },
    sort: {
      newest: 'الأحدث',
      budgetHigh: 'الميزانية: الأعلى',
      budgetLow: 'الميزانية: الأقل',
      urgent: 'الأكثر إلحاحاً',
    },
    noResults: 'لا توجد طلبات مطابقة',
    noResultsDesc: 'جرب تغيير معايير البحث',
    loadMore: 'تحميل المزيد',
    viewRequest: 'عرض الطلب',
    submitOffer: 'قدم عرضك',
    contactClient: 'تواصل مع العميل',
    alreadyResponded: 'قدمت عرضاً',
    leadPrice: 'سعر الطلب',
    purchaseLead: 'شراء بيانات التواصل',
    leadPurchased: 'تم شراء البيانات',
    // كانت تُستدعى بلا مفاتيح (النص نفسه الظاهر في الصفحة).
    loadError: 'تعذّر تحميل الطلبات. حاول مرة أخرى.',
    signIn: 'سجّل الدخول كوسيط معتمد لتصفح الطلبات.',
    agentsOnly: 'متاح للوسطاء المعتمدين فقط',
    agentsOnlyDesc: 'يجب أن يكون حسابك وسيطاً معتمداً لتصفح طلبات العملاء.',
  },

  // Submit offer modal
  offer: {
    title: 'قدم عرضك',
    subtitle: 'صف العقار الذي تريد عرضه على العميل',
    propertyTitle: 'عنوان العقار',
    propertyTitlePlaceholder: 'مثال: فيلا فاخرة في حي النرجس',
    propertyDescription: 'وصف العقار',
    propertyDescriptionPlaceholder: 'اكتب وصفاً تفصيلياً للعقار...',
    price: 'السعر المعروض',
    pricePlaceholder: 'أدخل السعر',
    location: 'موقع العقار',
    locationPlaceholder: 'الحي والشارع',
    attachProperty: 'أو اختر من عقاراتك',
    selectProperty: 'اختر عقاراً',
    message: 'رسالة للعميل',
    messagePlaceholder: 'اكتب رسالة قصيرة للعميل...',
    submit: 'إرسال العرض',
    cancel: 'إلغاء',
    success: 'تم إرسال عرضك بنجاح',
    error: 'حدث خطأ أثناء إرسال العرض',
  },

  // Validation messages
  validation: {
    propertyTypeRequired: 'يرجى اختيار نوع العقار',
    transactionTypeRequired: 'يرجى اختيار نوع الصفقة',
    cityRequired: 'يرجى اختيار المدينة',
    budgetRequired: 'يرجى تحديد الميزانية',
    budgetMinMax: 'الحد الأقصى يجب أن يكون أكبر من الحد الأدنى',
    nameRequired: 'يرجى إدخال الاسم',
    phoneRequired: 'يرجى إدخال رقم الجوال',
    phoneInvalid: 'رقم الجوال غير صحيح',
    emailInvalid: 'البريد الإلكتروني غير صحيح',
  },

  // General
  general: {
    sar: 'ريال',
    sqm: 'م²',
    room: 'غرفة',
    rooms: 'غرف',
    bathroom: 'دورة مياه',
    bathrooms: 'دورات مياه',
    any: 'أي',
    from: 'من',
    to: 'إلى',
    or: 'أو',
    required: 'مطلوب',
    optional: 'اختياري',
  },

  // العدد بعد الرقم على بطاقات الطلبات (BrokerRequestsList و MyRequests)، بصيغ الجمع
  // العربية كاملة: «3 غرف نوم» لا «3 عدد الغرف». الصيغ نفسها في home.v2.featured.beds_*.
  counts: {
    bedrooms_one: 'غرفة نوم واحدة',
    bedrooms_two: 'غرفتا نوم',
    bedrooms_few: '{{count}} غرف نوم',
    bedrooms_many: '{{count}} غرفة نوم',
    bedrooms_other: '{{count}} غرفة نوم',
    bathrooms_one: 'دورة مياه واحدة',
    bathrooms_two: 'دورتا مياه',
    bathrooms_few: '{{count}} دورات مياه',
    bathrooms_many: '{{count}} دورة مياه',
    bathrooms_other: '{{count}} دورة مياه',
    // عدد النتائج فوق قائمة الطلبات في BrokerRequestsList («3 نتائج» لا «3 نتيجة»).
    results_zero: 'لا توجد نتائج',
    results_one: 'نتيجة واحدة',
    results_two: 'نتيجتان',
    results_few: '{{count}} نتائج',
    results_many: '{{count}} نتيجة',
    results_other: '{{count}} نتيجة',
  },

  // نصوص صفحة سوق الطلبات (BrokerRequestsList) التي كانت تُستدعى بلا مفاتيح؛ القيم
  // هي النصوص الظاهرة نفسها، ووجود المفاتيح يمنع ظهورها بالعربية في الواجهة الإنجليزية.
  in: 'في',
  loadingText: 'جاري التحميل...',

  // معالج «أضف طلبك» (pages/client-requests/CreateClientRequest.tsx). القيم العربية
  // هي النصوص الظاهرة نفسها؛ وجود المفاتيح يمنع ظهورها بالعربية في الواجهة الإنجليزية.
  createRequestTitle: 'أضف طلبك',
  createRequestSubtitle: 'أخبرنا ما تبحث عنه وسيتواصل معك الوسطاء المعتمدون',
  stepperLabel: 'خطوات إضافة الطلب',
  requestTypeLabel: 'ماذا تبحث عن؟',
  rent: 'إيجار',
  buy: 'شراء',
  demandTypeLabel: 'نوع الطلب (لوحة الطلبات)',
  propertyTypeLabel: 'نوع العقار',
  cityLabel: 'المدينة',
  selectCity: 'اختر المدينة',
  districtsLabel: 'الأحياء المفضلة',
  districtsPlaceholder: 'أدخل الأحياء مفصولة بفاصلة',
  districtsHelp: 'مثال: النخيل، الملقا، الياسمين',
  budgetLabel: 'الميزانية (ر.س)',
  minBudget: 'الحد الأدنى',
  maxBudget: 'الحد الأقصى',
  bedroomsLabel: 'عدد غرف النوم',
  bathroomsLabel: 'عدد دورات المياه',
  minAreaLabel: 'الحد الأدنى للمساحة (م²)',
  minAreaPlaceholder: 'مثال: 150',
  moveInDateLabel: 'تاريخ الاستلام المتوقع',
  rentalDurationLabel: 'مدة الإيجار',
  selectDuration: 'اختر المدة',
  specialRequirementsLabel: 'متطلبات خاصة',
  specialRequirementsPlaceholder: 'مثال: قريب من مدرسة، مواقف سيارات، حديقة...',
  privateRequestLabel: 'طلب خاص',
  privateRequestDesc: 'لن يظهر طلبك علناً، فقط للوسطاء المعتمدين',
  nameLabel: 'الاسم',
  namePlaceholder: 'أدخل اسمك',
  phoneLabel: 'رقم الجوال',
  phonePlaceholder: '5xxxxxxxx',
  emailLabel: 'البريد الإلكتروني',
  emailPlaceholder: 'example@email.com',
  preferredContactLabel: 'طريقة التواصل المفضلة',
  previous: 'السابق',
  next: 'التالي',
  submitting: 'جاري الإرسال...',
  submitRequest: 'إرسال الطلب',
  errors: {
    missingContact: 'يرجى تعبئة الاسم والبريد الإلكتروني ورقم الجوال',
    missingType: 'يرجى اختيار نوع العقار',
    submit: 'تعذّر إرسال الطلب. يرجى المحاولة مرة أخرى.',
  },
};

export default clientRequests;
